import React from "react";

import { PrivyProvider, WalletListEntry } from "@privy-io/react-auth";
import { toSolanaWalletConnectors } from "@privy-io/react-auth/solana";
import { PRIVY_APP_ID } from "@bridgesplit/utils";
import { registerWalletAdapter } from "@solana/wallet-standard-wallet-adapter-base";
import { CoinbaseWalletAdapter } from "@solana/wallet-adapter-coinbase";

let registered = false;

function registerCoinbaseSolanaWallet(): void {
    if (registered) return;
    registered = true;
    // privy only listens for coinbase ethereum wallet, so we need to register it manually with solana:mainnet
    const adapter = new CoinbaseWalletAdapter();
    registerWalletAdapter(adapter, "solana:mainnet", undefined, (w) => w.name === "Coinbase Wallet");
}
registerCoinbaseSolanaWallet();

const solanaConnectors = toSolanaWalletConnectors({
    shouldAutoConnect: false
});

const config = {
    appearance: {
        walletChainType: "solana-only" as const,
        walletList: ["phantom", "detected_solana_wallets", "wallet_connect"] as WalletListEntry[]
    },
    externalWallets: {
        solana: {
            connectors: solanaConnectors
        }
    }
};

export function PrivyWalletProvider({ children }: { children: React.ReactNode }) {
    return (
        <PrivyProvider appId={PRIVY_APP_ID} config={config}>
            {children}
        </PrivyProvider>
    );
}
